<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">history</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Auditor&iacute;a de Conexiones</h1>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Tabs -->
  <div class="flex flex-wrap gap-2 mb-6">
    <button *ngFor="let tab of tabs" type="button"
      (click)="onTabChange(tab)"
      class="tab-button"
      [class.tab-button--active]="activeTab === tab.tipoId">
      {{ tab.label }}
    </button>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario (ID o Email)</mat-label>
            <input matInput formControlName="userId" placeholder="Ej: 12345 o email@mail.com" />
            <mat-icon matPrefix>person_search</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Fin</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando historial...</span>
  </div>

  <!-- Results -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading && records.length > 0">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
          Historial de Conexiones
        </h2>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-600" *ngIf="pagination.total > 0">
            {{ (pagination.page - 1) * pagination.limit + 1 }} -
            {{ Math.min(pagination.page * pagination.limit, pagination.total) }}
            de {{ pagination.total }}
          </span>
          <select [value]="pagination.limit" (change)="onPageSizeChange($event)"
            style="border: 1px solid #d1d5db; border-radius: 6px; padding: 2px 8px; font-size: 0.75rem; background: white; cursor: pointer;">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Cards -->
    <div class="space-y-3 p-4">
      <div *ngFor="let record of records; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <!-- Card header -->
        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">{{ record.userId }}</span>
            <span class="px-2 py-0.5 text-xs font-bold rounded-full shrink-0"
              [style.background]="getUserTypeBadge(record).color + '18'"
              [style.color]="getUserTypeBadge(record).color">
              {{ getUserTypeBadge(record).label }}
            </span>
            <span class="text-xs font-semibold text-gray-800 truncate">{{ record.nombre }} {{ record.apellidos }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold" style="color: #1C593D;">
              {{ record.connectionCount }} conexiones
            </span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <!-- Card body -->
        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Email</span>
              <p class="font-medium mt-0.5" style="color: #2563eb;">{{ record.email }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatDate(record.date) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Conexiones</span>
              <p class="font-bold mt-0.5" style="color: #1C593D;">{{ record.connectionCount }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Primera Conexi&oacute;n</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatTime(record.firstConnectionAt) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">&Uacute;ltima Conexi&oacute;n</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatTime(record.lastConnectionAt) }}</p>
            </div>
          </div>

          <!-- Action buttons -->
          <div style="display: flex; gap: 8px; margin-top: 12px; flex-wrap: wrap;">
            <button (click)="viewDetail(record); $event.stopPropagation()"
              style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #2563eb; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon>
              Ver detalle
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="p-4">
      <mat-paginator
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginatorChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <!-- Sin datos -->
  <div *ngIf="!loading && records.length === 0"
    class="bg-white rounded-2xl shadow-md border border-gray-100 text-center py-8">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">inbox</mat-icon>
    <p class="text-lg font-medium text-gray-500 mt-2">No se encontraron registros de conexiones</p>
    <p class="text-sm text-gray-400">Intenta ajustar los filtros de b&uacute;squeda</p>
  </div>
</div>
